import NodeTypeCrud from '../views/NodeType/Crud'
import NodeTypeAdd from '../views/NodeType/Add'
import NodeCrud from '../views/Node/Crud'
import NodeAdd from '../views/Node/Add'
import NodeAdmin from '../views/Node/Admin'
import DisciplineConfig from '../views/Node/DisciplineConfig'
import MaterialsAdmin from '../views/Materials/Admin'

const routes = {
  path: '/nodes-module',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    // NodeType
    {
      path: '/node_types',
      name: 'list-node-types',
      component: NodeTypeCrud,
      meta: {
        pageTitle: 'Tipos de Nós',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Tipos de Nós', active: true }],
      },
    },
    {
      path: '/node_types/add',
      name: 'NewNodeType',
      component: NodeTypeAdd,
      meta: {
        pageTitle: 'Tipo de Nó',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Adicionar Tipo de Nó', active: true }],
      },
    },
    {
      path: '/node_types/edit/:id?',
      name: 'EditNodeType',
      component: NodeTypeAdd,
      meta: {
        pageTitle: 'Tipo de Nó',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Editar Tipo de Nó', active: true }],
      },
    },

    // Node
    {
      path: '/nodes',
      name: 'list-nodes',
      component: NodeCrud,
      meta: {
        pageTitle: 'Nós',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Nós', active: true }],
      },
    },
    {
      path: '/nodes/add',
      name: 'NewNode',
      component: NodeAdd,
      meta: {
        pageTitle: 'Nó',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Adicionar Nó', active: true }],
      },
    },
    {
      path: '/nodes/edit/:id?',
      name: 'EditNode',
      component: NodeAdd,
      meta: {
        pageTitle: 'Nó',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Editar Nó', active: true }],
      },
    },
    {
      path: '/nodes/admin/:nodeId',
      name: 'AdminNode',
      component: NodeAdmin,
      meta: {
        pageTitle: 'Administrar Nó',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'Administrar Nó', active: true }],
      },
    },
    {
      path: '/nodes/admin/:nodeId/materials',
      name: 'NodeMaterials',
      component: MaterialsAdmin,
      meta: {
        pageTitle: 'Materiais do Nó',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Administrar Nó', to: { name: 'AdminNode' } },
          { text: 'Materiais', active: true },
        ],
      },
    },
    {
      path: '/nodes/admin/:nodeId/discipline/:disciplineId',
      name: 'NodeDisciplineConfig',
      component: DisciplineConfig,
      meta: {
        pageTitle: 'Configurar Disciplina',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Administrar Nó', to: { name: 'AdminNode' } },
          { text: 'Configurar Disciplina', active: true },
        ],
      },
    },
    {
      path: '/nodes/admin/:nodeId/discipline/:disciplineId/forms/:formDefinitionId/builder',
      name: 'FormBuilder',
      component: () => import('@/views/Node/FormBuilder/Index.vue'),
      meta: {
        pageTitle: 'Form Builder',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'Administrar Nó', to: { name: 'AdminNode' } },
          { text: 'Configurar Disciplina', to: { name: 'NodeDisciplineConfig' } },
          { text: 'Form Builder', active: true },
        ],
      },
    },
  ],
}

export default routes
